import React from "react";
import { COLUMNS } from "./Column";
import { Table } from "./Table";
import BuyOfferData from "./BuyOfferData";
import { LoadingMode } from "../Components/LoadingMode";
import { BuyandSellOfferTableModals } from "./BuyandSellOfferTableModals";
export const BuyTable = () => {
  const {
    buyOfferDataArray,
    handleOpenandCloseModal,
    offerDetails,
    cxId,
    openModal,
  } = BuyOfferData();
  return (
    <div className=" w-full">
      {buyOfferDataArray.length !== 0 ? (
        <div className="overflow-hidden">
          <Table columns={COLUMNS} data={buyOfferDataArray} />
        </div>
      ) : (
        // <LoadingMode />
        <div className="w-full">
          <div className="w-full h-full flex items-center justify-center">
            <p className="text-lg text-center">No data available</p>
          </div>
        </div>
      )}
      <BuyandSellOfferTableModals
        openModal={openModal}
        handleOpenandCloseModal={handleOpenandCloseModal}
        offerDetails={offerDetails}
        cxId={cxId}
      />
    </div>
  );
};
